import * as React from "react";
const Hamburger = props => <symbol viewBox="0 0 24 24" {...props}>
    <path d="M21 5.75H3a.75.75 0 010-1.5h18a.75.75 0 110 1.5zm0 7H3a.75.75 0 110-1.5h18a.75.75 0 110 1.5zm0 7H3a.75.75 0 110-1.5h18a.75.75 0 110 1.5z" />
  </symbol>;
export default Hamburger;